export default __webpack_public_path__ + "static/brilliantly-warm-banner-4-3e3fc14ba33ba752def3e0b52da570e9.webp";